import React, { Component } from 'react';
import { Container, Card, Row, Col } from 'react-bootstrap';
import { t } from '../../helpers/translation_helper';
import NavBar from '../_partials/NavBar/_NavBar';
import Header from '../_partials/Header/_Header';
import { connect } from 'react-redux';
import {
  changeColorOpacity,
  ifNavAllowed,
} from '../../helpers/general_helpers';
import { NavLink, Outlet } from 'react-router-dom';
import { brand_colors } from '../../helpers/brand_colors_helper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faDashboard,
  faWarehouse,
} from '@fortawesome/free-solid-svg-icons';

class InventoryDashboard extends Component {
  state = {
  };

  render() {
    const { lang_orientation: dir } = this.props.defaultLanguage;

    return (
      <div></div>
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  defaultLanguage: state.language.defaultLanguage,
  defaultTheme: state.theme.defaultTheme,
});

export default connect(mapStateToProps, null)(InventoryDashboard);
